import "./App.css";
import { LoginSignUp } from "./Components/LoginSignUp/LoginSignUp";
import { Header } from "./Components/Home/Header/Header";
import Story from "./Pages/Story";
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import Profile from "./Components/Profile/Profile";
import SavedStories from "./Components/LikedStories/LikedStories";
import OpenStory from "./Components/Home/OpenStory/OpenStory";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import LikedStories from "./Components/LikedStories/LikedStories";
import Quiz from "./Components/Home/Quiz/Quiz";
import MyStory from "./Pages/MyStory/MyStory";
import Admin from "./Components/admin.js";
import CreateOptions from './Pages/CreateStory/CreateOptions';
import MyStories from "./Components/MyStories/MyStories";
import QuizGeneration from "./Pages/QuizGeneration/QuizGeneration";
import StoryForm from "./Pages/CreateStory/StoryForm.jsx";
import PersonaPicker from "./Pages/PersonaPicker/PersonaPicker";
import KnowledgeGraph from "./Pages/KnowledgeGraph/KnowledgeGraph";
import FeedbackForm from "./Pages/FeedbackForm/FeedbackForm";
import Footer from "./Components/Common/Footer/Footer";
import About from "./Pages/About/About";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import DataDeletion from "./Pages/DataDeletion/DataDeletion";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route
            path="/Story"
            element={<ProtectedRoute element={<Story />} />}
          />
          <Route
            path="/Story/:id"
            element={<OpenStory />}
          />
          <Route
            path="/quiz/:id"
            element={<ProtectedRoute element={<Quiz />} />}
          />
          <Route
            path="/Contact"
            element={<ProtectedRoute element={<Contact />} />}
          />
          <Route
            path="/Profile"
            element={<ProtectedRoute element={<Profile />} />}
          />
          <Route
            path="/LikedStories"
            element={<ProtectedRoute element={<LikedStories />} />}
          />
          <Route
            path="/MyStory"
            element={<ProtectedRoute element={<MyStory />} />}
          />

          <Route path="/create" element={<PersonaPicker />} />
          <Route path="/create/story" element={<StoryForm />} />
          <Route path="/create-options" element={<CreateOptions />} />
          <Route path="/knowledge" element={<KnowledgeGraph />} />
          <Route path="/my-stories" element={<ProtectedRoute element={<MyStories />} />} />
          <Route 
            path="/generateQuiz/:storyId" 
            element={<ProtectedRoute element={<QuizGeneration />} />} 
          />
          <Route path="/feedback/:storyId" element={<FeedbackForm />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />

          <Route
            path="/admin"
            element={<ProtectedRoute element={<Admin />} />}
          />
          
          
          <Route
            path="/Login"
            element={<LoginSignUp />}
          />
          <Route
            exact
            path="/"
            element={<Home />}
          />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
